// extracted by mini-css-extract-plugin
module.exports = {"alertList":"alert_alertList__3RqXK","alertListItem":"alert_alertListItem__pFXQz","primary":"alert_primary__3tkwy","danger":"alert_danger__2FY8H","success":"alert_success__exNJC"};